import React from 'react';

const Blog = () => {
    return (
        <div className="container py-5">
            <div className=" my-4 py-4">
                <h2>My Blogs</h2>
                <hr style={{ width: '5%', backgroundColor: '#64ffda', fontWeight: '800', height: '2px', marginTop: '7px' }} />
            </div>

            <h2>Coming Soon</h2>
        </div>

    );
};

export default Blog;